// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__160nY","col":"styles_col__hLtp2"};